import web from "../web";

class GrillestarifairesService {
    index(token){
        return web.get("/api/grillestarifaires", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/grillestarifaires", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/grillestarifaires/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/grillestarifaires/update", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/grillestarifaires/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    getMontant(idTypeInscription,idClasse,token){
        return web.get(`/api/grillestarifaires/${idTypeInscription}/${idClasse}/fraisinscription`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    getFraisDivers(idClasse,token){
        return web.get(`/api/grillestarifaires/${idClasse}/fraisdivers`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new GrillestarifairesService()